<template>
  <div class="rt-detail-item">
    <div
      v-if="title"
      class="detail-item-header"
    >
      <div class="detail-item-icon">
        <rt-icon
          :name="icon"
          :size="18"
        ></rt-icon>
      </div>
      <span class="detail-item-title">{{ title }}</span>
      <div class="detail-item-btns">
        <slot name="btn" />
      </div>
    </div>
    <div class="detail-item-content">
      <slot />
    </div>
  </div>
</template>

<script>
import RtIcon from '../../icon/rtIcon.vue';
export default {
  name: 'RtDetailItem',
  components: { RtIcon },
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDetailItem.vue?11d159dd